import { render, staticRenderFns } from "./voiceGalleryMobile.vue?vue&type=template&id=18822d78&scoped=true"
import script from "./voiceGalleryMobile.vue?vue&type=script&lang=js"
export * from "./voiceGalleryMobile.vue?vue&type=script&lang=js"
import style0 from "./voiceGalleryMobile.vue?vue&type=style&index=0&id=18822d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18822d78",
  null
  
)

export default component.exports